"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarHeadingItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _form = require("../../form");

var _interfaces = require("../interfaces");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ToolbarHeadingItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var disabled = _ref.disabled,
      paragraphControl = _ref.paragraphControl,
      headingControl = _ref.headingControl,
      editorInstance = _ref.editorInstance;
  var options = (0, _react.useMemo)(function () {
    var newOptions = [];

    if (paragraphControl) {
      newOptions.push({
        title: paragraphControl.title,
        value: _interfaces.Commands.paragraph
      });
    }

    if (headingControl && headingControl.options && headingControl.options.levels) {
      headingControl.options.levels.forEach(function (level) {
        newOptions.push({
          title: "".concat(headingControl.title, " ").concat(level),
          value: _interfaces.Commands.heading,
          level: level
        });
      });
    }

    return newOptions;
  }, [paragraphControl, headingControl]);
  var changeHandler = (0, _react.useCallback)(function (option) {
    if (option.value === _interfaces.Commands.paragraph) editorInstance.commands.paragraph.set();
    if (option.value === _interfaces.Commands.heading && option.level) editorInstance.commands.heading.set(option.level);
  }, [editorInstance]);
  var activeOption = options.find(function (o) {
    return o.value === _interfaces.Commands.heading ? editorInstance.isActive(_interfaces.Commands.heading, {
      level: o.level
    }) : editorInstance.isActive(o.value);
  });
  return (0, _core.jsx)(_form.Select, {
    ref: ref,
    disabled: disabled,
    onChange: changeHandler,
    options: options,
    value: disabled ? options[0] : activeOption,
    valueAccessor: function valueAccessor(o) {
      return o.value + (o.level || '');
    },
    renderOption: function renderOption(o) {
      return o.title;
    },
    renderNativeOption: function renderNativeOption(o) {
      return o.title;
    },
    width: 160,
    "aria-label": "Paragraph and headings",
    "aria-labelledby": null
  });
});
exports.ToolbarHeadingItem = ToolbarHeadingItem;